﻿import $ from "jquery";

$(function () {
    $.fn.DocReaderLink = function () {
        function init(obj) {
            // Find the anchor tag to couple the docreader link to
            var documentTag = obj.prev("a");
            if (documentTag != undefined) {
                // document url to be used in the docReader link
                var href = documentTag.attr("href");
                var docreaderUrl = "https://docreader.readspeaker.com/docreader/?cid=cedyi&lang=da_dk&url=" + href;
                
                obj.attr("href", docreaderUrl);
            }
        }

        this.each(function () {
            init($(this));
        });
    }
    $(".docreader-link").DocReaderLink();
});





//////////////////
// WEBPACK FOOTER
// ./Scripts/ReadSpeak/DocReaderLink.js
// module id = 18
// module chunks = 1